import moment from "moment";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {API_BASE_URL} from "../plugins/axios";
import {useCookies} from "react-cookie";
import makeKCPGoodInfo from "../utils/makeKCPGoodInfo";

const CartPaymentProcessing = () => {
    const history = useHistory();
    // @ts-ignore
    const {paymentInfo, orderInfo, orderProducts} = history.location.state;
    const [isFail, setIsFail] = useState(false);
    const [cookies] = useCookies();
    const [isApp, setIsApp] = useState<boolean | undefined>();

    useEffect(() => {
        if (!paymentInfo || !orderInfo) {
            setIsFail(true);
            return;
        }
        if (!!cookies['request-client']) {
            setIsApp(true);
        } else {
            setIsApp(false);
        }
    }, []);

    useEffect(() => {
        if (isApp !== undefined && paymentInfo) {
            jsf__chk_type();

            // @ts-ignore
            const form = document.order_info;
            form.action = paymentInfo.mobilePayUrl;
            form.submit();
        }
    }, [paymentInfo, isApp]);

    function jsf__chk_type() {
        // @ts-ignore
        const frm = document.order_info;
        switch (orderInfo.payMethod) {
            case 'CARD':
                frm.pay_method.value = 'CARD';
                break;
            case 'TRANSFER':
                frm.pay_method.value = 'BANK';
                break;
            case 'VIRTUAL_ACCOUNT':
                frm.pay_method.value = 'VCNT';
                break;
        }
    }

    const ipgmDate = moment(new Date()).add(1, 'days').format('YYYYMMDDHHmmss');

    if (isFail || !paymentInfo) {
        return <div>결제 정보가 없거나 잘못된 접근입니다.</div>;
    }

    return (
        <div className="h-full">
            처리 중입니다.
            <form name="order_info" method="post" acceptCharset="euc-kr">
                {/* 주문 필수 정보 */}
                <input type="hidden" name="good_name" value="칼하트윕"/>
                <input type="hidden" name="ordr_idxx" value={paymentInfo.orderNumber}/>
                <input type="hidden" name="good_mny" value={paymentInfo.totalPrice}/>
                <input type="hidden" name="buyr_name" value={orderInfo.customerName}/>
                <input type="hidden" name="tno" value={paymentInfo.traceNo}/>
                <input type="hidden" name="approval_key" value={paymentInfo.approvalKey}/>
                <input type="hidden" name="buyr_tel1" value={orderInfo.customerPhone}/>
                <input type="hidden" name="buyr_tel2" value=""/>
                <input type="hidden" name="buyr_mail" value=""/>
                <input type="hidden" name="pay_method" value="VCNT"/>
                <input type="hidden" name="ActionResult" value="acnt"/>
                <input type="hidden" name="pay_mod" value="N"/>

                {/*요청 구분 */}
                <input type="hidden" name="req_tx" value="pay"/>
                {/*사이트 이름 */}
                <input type="hidden" name="shop_name" value="칼하트"/>
                {/* 사이트 키 - 테스트용/실서버용 */}
                <input type="hidden" name="site_cd" value={process.env.REACT_APP_SITE_CODE} />

                {/* 통화 코드 */}
                <input type="hidden" name="currency" value="410"/>
                {/* 인증시 필요한 파라미터(변경불가)*/}
                <input type="hidden" name="van_code" value=""/>
                {/* 신용카드 설정 */}
                {/* 최대 할부개월수 */}
                <input type="hidden" name="quotaopt" value="12"/>
                {/*가상계좌 설정 */}
                <input type="hidden" name="ipgm_date" value={ipgmDate}/>

                {/* 리턴 URL (kcp와 통신후 결제를 요청할 수 있는 암호화 데이터를 전송 받을 가맹점의 주문페이지 URL) */}
                <input type="hidden"
                       name="Ret_URL"
                       value={`${API_BASE_URL}/v1/orders/payments/confirm/mobile/carhartt`}
                />
                {/* App에서 결제 시 AppScheme 전달 */}
                <input type="hidden" name="AppUrl" value={isApp ? "carhartt://" : ""}/>
                {/* 화면 크기조정 */}
                <input type="hidden" name="tablet_size" value="1.0"/>

                {/*추가 파라미터 ( 가맹점에서 별도의 값전달시 param_opt 를 사용하여 값 전달 ) */}
                <input type="hidden" name="param_opt_1" value=""/>
                <input type="hidden" name="param_opt_2" value=""/>
                <input type="hidden" name="param_opt_3" value=""/>

                {/*결제 정보 등록시 응답 타입 ( 필드가 없거나 값이 '' 일경우 TEXT, 값이 XML 또는 JSON 지원 */}
                <input type="hidden" name="response_type" value="JSON"/>
                <input type="hidden" name="PayUrl" id="PayUrl" value={paymentInfo.mobilePayUrl}/>
                <input type="hidden" name="traceNo" value={paymentInfo.traceNo}/>
                <input type="hidden" name="encoding_trans" value="UTF-8"/>

                {/* 에스크로 사용유무 에스크로 사용 업체(가상계좌, 계좌이체 해당)는 escw_used 를 Y로 세팅 해주시기 바랍니다. */}
                <input type="hidden" name="escw_used" value="Y"/>
                {/*장바구니 상품 개수*/}
                <input type="hidden" name="bask_cntx" value={orderProducts.length}/>
                <input type="hidden" name="good_info" value={makeKCPGoodInfo(orderProducts, orderInfo.orderNumber)}/>
                {/*배송소요기간*/}
                <input type="hidden" name="deli_term" value="03"/>
            </form>
        </div>
    )
}

export default CartPaymentProcessing;